import { render, staticRenderFns } from "./LoadingPlaceholder.vue?vue&type=template&id=f8f697a8&scoped=true"
import script from "./LoadingPlaceholder.vue?vue&type=script&lang=js"
export * from "./LoadingPlaceholder.vue?vue&type=script&lang=js"
import style0 from "./LoadingPlaceholder.vue?vue&type=style&index=0&id=f8f697a8&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8f697a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f8f697a8')) {
      api.createRecord('f8f697a8', component.options)
    } else {
      api.reload('f8f697a8', component.options)
    }
    module.hot.accept("./LoadingPlaceholder.vue?vue&type=template&id=f8f697a8&scoped=true", function () {
      api.rerender('f8f697a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/modules/shared/components/LoadingPlaceholder.vue"
export default component.exports